// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"shopping_wrapper__2eMax","left":"shopping_left__2HWV4","right":"shopping_right__2SH21"};